module.exports = __webpack_public_path__ + "static/media/management_key_green.b72dc502.svg";